import React, { useContext, useEffect } from "react";
import DisSuccess from "./success";
import { UserContext } from "../../context/userContext";
import DashboardAPI from "../../api/commercial/dashboard";
import { ProductContext } from "../../context/product-context/productContext";
import DashboardHelper from "../../pages/dashboard/helper";
import { ProductRefType } from "../../context/product-context/types";
import { useNavigate } from "react-router-dom";

const DisSuccessRoute = (): React.JSX.Element => {
  const { setSelectedProduct, selectedProduct, findPersistedProductByRef } =
    useContext(ProductContext);
  const { isUserLogged } = useContext(UserContext);

  const navigate = useNavigate();

  useEffect(() => {
    DashboardAPI.query().then((finishedApplications) => {
      setSelectedProduct(
        findPersistedProductByRef(
          DashboardHelper.getLatestModifiedApplication(finishedApplications)
            .productRef as ProductRefType,
        ),
      );
    });
  }, [findPersistedProductByRef, setSelectedProduct]);

  const goToApp = () => {
    navigate("/");
  };

  const goToLogin = () => {
    navigate("/login");
  };

  const goNext = isUserLogged ? goToApp : goToLogin;

  if (selectedProduct === undefined) {
    return null;
  }

  return (
    selectedProduct && <DisSuccess next={goNext} loggedIn={isUserLogged} />
  );
};

export default DisSuccessRoute;
